module.exports = __webpack_public_path__ + "static/img/img_12.de684c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/production/images/img_12.png
// module id = vdc3
// module chunks = 8